import React from 'react';
import Spinner from '@atlaskit/spinner';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';

import Button from '@/components/Button';
import Field from '@/components/forms/Field';
import { useIsMobile } from '@/hooks';
import { trackEvent } from '@/lib/GA';
import UserService from '@/lib/UserService';

import styles from '../styles.module.scss';

interface ForgotPasswordValues {
  email: string;
}

interface Props {
  sent: boolean;
  setSent: (value: React.SetStateAction<boolean>) => void;
}

function ForgotPasswordForm({ sent, setSent }: Props) {
  const [isMobile] = useIsMobile(768);

  const handleSubmit = async (values: ForgotPasswordValues, { setSubmitting }: FormikHelpers<ForgotPasswordValues>) => {
    setSubmitting(true);
    trackEvent('forgot password', 'request new password');
    await UserService.resetPassword(values.email);
    setSent(true);
    setSubmitting(false);
  };

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={{ email: '' }}
      validationSchema={object({ email: string().email('Please enter a valid email').required() })}
    >
      {({ errors, isSubmitting, isValid, values }) => (
        <Form>
          {isSubmitting ? (
            <div className={styles.spinner}>
              <Spinner size="large" />
            </div>
          ) : (
            <>
              {sent && !isMobile && <div className={styles.tryAgain}>Didn’t get the email? Try again.</div>}
              <Field name="email" type="email" label="Email" required errors={errors} formik />
              <Button type="submit" disabled={!isValid || !values.email}>
                Send Email
              </Button>
            </>
          )}
        </Form>
      )}
    </Formik>
  );
}

export default ForgotPasswordForm;
